import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from "react-router-dom";

import Django from './Django'
import Python from './Python'
import Common from './Common'
import ScrollToTop from '../components/ScrollToTop'

// "features" as features is reserved github name, so no repo org can be that name, so does not clash with repo link
export default function App() {
  return (
    <Router>  
      <ScrollToTop />      
      <Switch>
        <Route path="/features/python" component={Python} />
        <Route path="/features/django" component={Django} />
        <Route path="/" component={Common} />
      </Switch>
    </Router>
  );
}